import React, { useEffect } from "react";
import { Control, FieldValues, useForm } from "react-hook-form";
import SelectField from "components/UI/SelectField";
import {
  PHOTO_SERIES_TYPE_OPTIONS,
  PHOTO_SERIES_TYPES,
} from "constant/photo_series/photo_series_type.constant";

type PhotoSeriesTypeSelectProps<T extends FieldValues = FieldValues> = {
  control?: Control<T>;
  defaultValue?: string;
  label?: string;
  name?: string;
  onSelect?: (value: string) => void;
};

const PhotoSeriesTypeSelect = <T extends FieldValues = FieldValues>({
  control,
  defaultValue = PHOTO_SERIES_TYPES.FOTOGRAFIJE,
  label = "Tip korisnika",
  name = "uType",
  onSelect,
}: PhotoSeriesTypeSelectProps<T>) => {
  const { control: localControl, reset } = useForm({
    defaultValues: {
      [name]: defaultValue,
    },
  });

  useEffect(() => {
    if (!control) {
      reset({
        [name]: defaultValue,
      });
    }
  }, [control, defaultValue, name, reset]);

  return (
    <>
      <SelectField
        name={name}
        control={(control ?? localControl) as Control<any>}
        label={label}
        defaultValue={defaultValue}
        options={PHOTO_SERIES_TYPE_OPTIONS}
        onSelect={onSelect}
      />
    </>
  );
};

export default PhotoSeriesTypeSelect;
